import { useStyles } from 'react-treat'

import * as styleRefs from './useFadedDiamondBackground.treat'

export const useFadedDiamondBackground = (
  variant: keyof typeof styleRefs,
  direction: 'left' | 'right' | 'top',
) => useStyles(styleRefs)[variant][direction]
